import React from "react";
import { useRef, useState } from "react";

import { FormHelperText } from "@mui/material";
import { useController } from "react-hook-form";
import { useTranslation } from "react-i18next";
import DatePicker from "react-multi-date-picker";

import { ReactComponent as ArrowDown } from "../../../../Assets/Images/ArrowDown.svg";
import { FormItemsWrap } from "../../../molecules/Wrap/Wrap";
import Label from "../../Input/Label";
import "../CalenderDateRange/CustomSyles.css";

const Calender = ({
  control,
  name,
  width,
  height,
  label,
  required,
  enableMaxDate,
  fontSize,
  placeholder,
}) => {
  const { t } = useTranslation();
  const { field, fieldState } = useController({
    name: name,
    control: control,
    defaultValue: null,
  });
  const [dropdownIconDegree, setDropdownIconDegree] = useState(0);

  const datePickerRef = useRef();

  return (
    <FormItemsWrap>
      {label && <Label label={label} required={required} />}

      <div style={{ position: "relative", width: width }}>
        <DatePicker
          ref={datePickerRef}
          className="custom-calendar"
          containerClassName="custom-container"
          style={{
            fontSize: fontSize || "13px",
            cursor: "pointer",
            boxSizing: "content-box",
            display: "flex",
            letterSpacing: "inherit",
            width: width,
            height: height || null,
            padding: "12px",
            paddingLeft: "12px",
            borderColor:
              fieldState?.invalid && fieldState?.error ? "red" : "#E5E5EA",
          }}
          placeholder={placeholder || "dd/mm/yyyy - dd/mm/yyyy"}
          inputProps={{
            style: {
              width: width,
            },
          }}
          range
          rangeHover
          dateSeparator=" - "
          value={field.value}
          weekDays={[
            t("common:date-picker.days-short.su"),
            t("common:date-picker.days-short.mon"),
            t("common:date-picker.days-short.tue"),
            t("common:date-picker.days-short.we"),
            t("common:date-picker.days-short.th"),
            t("common:date-picker.days-short.fr"),
            t("common:date-picker.days-short.sa"),
          ]}
          months={[
            t("common:date-picker.months-long.jan"),
            t("common:date-picker.months-long.feb"),
            t("common:date-picker.months-long.mar"),
            t("common:date-picker.months-long.apr"),
            t("common:date-picker.months-long.may"),
            t("common:date-picker.months-long.jun"),
            t("common:date-picker.months-long.jul"),
            t("common:date-picker.months-long.aug"),
            t("common:date-picker.months-long.sep"),
            t("common:date-picker.months-long.oct"),
            t("common:date-picker.months-long.nov"),
            t("common:date-picker.months-long.dec"),
          ]}
          format="DD/MM/YYYY"
          monthYearSeparator=""
          onChange={(value) => {
            field.onChange(value);
          }}
          arrow={false}
          maxDate={enableMaxDate ? new Date() : null}
          editable={false}
          weekStartDayIndex={1}
          onOpen={() => setDropdownIconDegree(180)}
          onClose={() => setDropdownIconDegree(0)}
        />

        <ArrowDown
          role="img"
          type="img"
          aria-label="ArrowDown Icon"
          style={{
            position: "absolute",
            zIndex: 5,
            top: "calc(50% - 0.4em)",
            right: "-17px",
            transform: `rotate(${dropdownIconDegree}deg)`,
            WebkitTransform: `rotate(${dropdownIconDegree}deg)`,
            cursor: "pointer",
          }}
          onClick={() => {
            dropdownIconDegree == 0
              ? datePickerRef.current.openCalendar()
              : datePickerRef.current.closeCalendar();
          }}
        />
      </div>

      {fieldState?.error?.message && (
        <FormHelperText style={{ color: "red" }}>
          {fieldState?.error?.message}
        </FormHelperText>
      )}
    </FormItemsWrap>
  );
};

export default Calender;
